import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import {
  DEFAULT_LABEL_HEIGHT_CELLS,
  DEFAULT_LABEL_WIDTH_CELLS,
  FLOOR_PLAN_COLS,
  FLOOR_PLAN_ROWS,
  MIN_PLACEMENT_CELLS,
} from '../../utils/floorPlan';
import { zText } from '../primitives';

/** A reference-only text annotation on a floor plan. Geometry is in grid cells. */
export const labelPlacementSchema = z.object({
  /** Free text shown on the canvas, e.g. "Bar", "Kitchen". */
  text: z.string().default('Label'),
  uuid: z.string().default(() => uuidv4()),

  x: z.number().int().default(0),
  y: z.number().int().default(0),
  width: z.number().int().default(DEFAULT_LABEL_WIDTH_CELLS),
  height: z.number().int().default(DEFAULT_LABEL_HEIGHT_CELLS),
  rotation: z.number().default(0),
});
export type LabelPlacement = z.output<typeof labelPlacementSchema>;

/** Strict schema */
export const labelPlacementStrictSchema = labelPlacementSchema.safeExtend({
  text: zText.pipe(z.string().min(1).max(30)),
  uuid: z.guid(),
  width: z.int().min(MIN_PLACEMENT_CELLS).max(FLOOR_PLAN_COLS),
  height: z.int().min(MIN_PLACEMENT_CELLS).max(FLOOR_PLAN_ROWS),
});

/** Convex schema */
export const labelPlacementCvxSchema = labelPlacementSchema;
export type LabelPlacementCvx = z.output<typeof labelPlacementCvxSchema>;
